import React, { useCallback, useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import LineTaxiIcon from 'LuxKit/Icons/line/LineTaxiIcon'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import ModalContext from 'contexts/ModalContext'
import TasteOfGoldLearnMoreModal from './TasteOfGoldLearnMoreModal'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${props => props.theme.palette.product.loyalty.gold.darkForeground};
`

const InfoButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: ${props => props.theme.palette.neutral.default.three};
`

function TasteOfGoldTileBenefitMessage() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const openLearnMore = useCallback((event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    showModal(<TasteOfGoldLearnMoreModal />)
  }, [showModal])

  const program = getLoyaltyProgramDisplayName()
  const tier = getLoyaltyTierDisplayName('gold')

  const ariaLabel = intl.formatMessage(
    {
      id: 'LRCDr0txoQ',
      defaultMessage: 'Learn more about {program} {tier}',
      description: 'Aria label for info button in Taste of Gold tile benefit message',
    },
    { program, tier },
  )

  return (
    <Group direction="horizontal" gap={4} verticalAlign="center">
      <IconWrapper>
        <LineTaxiIcon size="S" />
      </IconWrapper>
      <BodyText variant="medium">
        <FormattedMessage
          id="pNjd1Ge/pq"
          defaultMessage="<strong>Experience {program} {tier}</strong> with a free airport transfer. Limited time only {infoButton}"
          description="Tile benefit message for Taste of Gold campaign with free airport transfer"
          values={{
            program,
            tier,
            strong: (chunks) => <strong>{chunks}</strong>,
            infoButton: <InfoButton onClick={openLearnMore} aria-label={ariaLabel}>
              <LineInfoCircleIcon size="S" />
            </InfoButton>,
          }}
        />
      </BodyText>
    </Group>
  )
}

export default TasteOfGoldTileBenefitMessage
